import loadingGif from 'assets/splash/okletsplayLoading.gif';
import React, { FC, useCallback } from 'react';

import { useStyles } from './Loader.styles';
import { Box } from '@mui/material';

export interface LoaderProps {
  size?: number;
}

export const Loader: FC<LoaderProps> = ({ size = 100 }) => {
  const { classes } = useStyles({ size });

  const onClickHandler = useCallback((event) => event.stopPropagation(), []);

  return (
    <Box className={classes.root} onClick={onClickHandler}>
      <Box className={classes.container}>
        <img src={loadingGif} alt="loader" />
      </Box>
    </Box>
  );
};
